import { render } from "./sv-el-table-v2.vue?vue&type=template&id=6410d3b5&ts=true"
import script from "./sv-el-table-v2.tsx?vue&type=script&lang=tsx&external"
export * from "./sv-el-table-v2.tsx?vue&type=script&lang=tsx&external"

import "./sv-el-table-v2.vue?vue&type=style&index=0&id=6410d3b5&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__